import { render } from "./ViewBonRetourPage.vue?vue&type=template&id=3ea194cb&ts=true"
import script from "./ViewBonRetourPage.vue?vue&type=script&lang=ts"
export * from "./ViewBonRetourPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__